import { mainIconSize } from '@/constants';
import { InstrumentRunStatus } from '@/types';
import { UseHoverProps } from '@floating-ui/react';
import { Badge, BadgeVariants } from '@nautilusbio/nb-design-system/Badge';
import { TextSizes } from '@nautilusbio/nb-design-system/helpers';
import { cssVar } from '@nautilusbio/nb-design-system/styles/css-variables';
import { Tooltip } from '@nautilusbio/nb-design-system/Tooltip';
import clsx from 'clsx';
import { LucideIcon } from 'lucide-react';
import React, { FC } from 'react';

import styles from './styles.module.css';

const statuses: Record<InstrumentRunStatus, { accentColor?: string; color?: string; variant: BadgeVariants }> = {
  COMPLETED: {
    variant: 'success',
  },
  DRAFT: {
    variant: 'default',
  },
  SUBMITTED: {
    accentColor: cssVar.color.tertiary3,
    color: cssVar.color.lightBlue,
    variant: 'unstyled',
  },
};

const hoverOptions: UseHoverProps = {
  delay: {
    close: 0,
    open: 1000,
  },
};

export type StatusBadgeProps = {
  showIcon?: LucideIcon;
  size?: TextSizes;
  status: InstrumentRunStatus;
};

const StatusBadge: FC<StatusBadgeProps> = ({ showIcon, size = 'md', status }) => {
  const { accentColor, color, variant } = statuses[status];
  const isTiny = size === 'xs3';
  const Icon = showIcon;

  return (
    <Tooltip
      content={status}
      hoverOptions={hoverOptions}
      isDisabled={!isTiny}
      placement="left"
      trigger={
        <Badge
          accentColor={accentColor}
          className={clsx(styles.badge, isTiny && styles.sm_xs3, !!showIcon && styles.showIcon)}
          color={color}
          size={size}
          variant={variant}
        >
          {status}
          {Icon && <Icon size={mainIconSize} />}
        </Badge>
      }
    />
  );
};

export default StatusBadge;
